module.exports = __webpack_public_path__ + "media/images/icons/email-aa0045e1e6e45bd7fb58378a00f3f265.svg";